<script>
  import { pages } from '../../models/pages.js'
  import { onMount } from 'svelte'

  onMount(async () => {
    await pages.loadPages()
  })
</script>

<style>
  .footer {
    background: hsla(180, 2%, 10%, 1);
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    justify-content: space-between;
    margin-top: 2rem;
  }
  .footer-cont {
    display: flex;
    flex-wrap: wrap;
    margin-left: 2rem;
    column-gap: 2rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .footer-header {
    color: var(--col-bg);
    line-height: calc(var(--line-height) * 1.5);
  }
  .footer-link {
    color: var(--col-gray-80);
    line-height: var(--line-height);
    position: relative;
    text-decoration: none;
  }
  .footer-link:hover,
  .footer-link:focus {
    color: var(--col-accent-1);
  }
  .footer-links {
    grid-gap: var(--spacing-sm);
    max-width: 100%;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: column;
  }

  .footer-text {
    background-color: var(--col-gray-0);
    color: var(--col-gray-80);
    text-align: center;
    padding: 10px;
  }

  .footer-text span {
    font-size: 14px;
    font-weight: 500;
  }

  .denver {
    color: var(--col-gray-60);
    font-weight: 300;
    font-size: 12px;
  }

  .footer-logo {
    margin-top: 20px;
  }

  @media (max-width: 850px) {
    .footer-links {
      flex-direction: column;
      /* Recommended for mobile */
      min-height: 48px;
      min-width: 48px;
    }

    .footer-cont {
      flex-direction: column;
      flex-wrap: nowrap;
    }
  }
</style>

<footer class="footer">
  <div class="footer-cont">
    <a class="footer-logo nav-link" href="/">
      <img
        rel="preload"
        src="/assets/logo-white.svg"
        alt="Missing Piece Puzzle Exchange" />
    </a>
    <nav class="footer-nav">
      <h1 class="footer-header h4">Connect with us</h1>
      <!-- TODO: Pull these from database too? -->
      <div class="footer-links">
        <a
          target="_blank"
          class="footer-link"
          href="https://www.facebook.com/PuzzleExchange.MissingPiece"
          rel="noreferrer">
          <svg class="icon">
            <use href="/icons.svg#facebook-square" />
          </svg>
          Facebook
        </a>
        <a
          target="_blank"
          class="footer-link"
          href="https://www.instagram.com/puzzle.exchange"
          rel="noreferrer">
          <svg class="icon">
            <use href="/icons.svg#instagram" />
          </svg>
          Instagram
        </a>
        <a target="_blank" class="footer-link" href="/blog" rel="noreferrer">
          Blog
        </a>
      </div>
    </nav>
    <nav class="footer-nav">
      <h1 class="footer-header h4">About</h1>
      <div class="footer-links">
        {#if $pages}
          {#each $pages.filter((p) => p.active == true) as page}
            {#if page.type === 'support'}
              <a class="footer-link" href="/{page.url_path}">{page.name}</a>
            {/if}
          {/each}
        {/if}
        <a class="footer-link" href="/redeem">Redeem a Gift</a>
        <a class="footer-link" href="/gift-card/balance">
          Check Gift Card Balance
        </a>
      </div>
    </nav>
  </div>
  <div class="footer-text">
    <span>
      © {new Date().getFullYear()} Missing Puzzle Piece, LLC All Rights Reserved
    </span>
    <br />
    <span class="denver">Founded in Denver, Colorado</span>
  </div>
</footer>
